/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DamageDto,
  DamageModelDataDto,
  FleetCreateDamageRequestDto,
  FleetDamagePageDto,
  MarkDamageDuplicateRequestDto,
  SearchDamagesParams,
  SearchDamagesRequestDto,
  UpdateDamageStatusRequestDto
} from '../../models';

import { customInstance } from '../../../../custom-instance';
import type { ErrorType , BodyType } from '../../../../custom-instance';




/**
 * Filters damages by vehicle, status and reporting period, newest first. Unlike the other reads on this controller this endpoint is genuinely paged: page defaults to 0 and size to 20, and totalElements reflects the whole result set rather than the current page. An empty result is a 200 with an empty items list.
 * @summary Search damages with filters and pagination, sorted by creation date (newest first)
 */
export const searchDamages = (
    searchDamagesRequestDto: BodyType<SearchDamagesRequestDto>,
    params?: SearchDamagesParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<FleetDamagePageDto>(
      {url: `/fleet/incident/v1/damages/search`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: searchDamagesRequestDto,
        params, signal
    },
      );
    }
  


export const getSearchDamagesMutationOptions = <TError = ErrorType<null | null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchDamages>>, TError,{data: BodyType<SearchDamagesRequestDto>;params?: SearchDamagesParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof searchDamages>>, TError,{data: BodyType<SearchDamagesRequestDto>;params?: SearchDamagesParams}, TContext> => {

const mutationKey = ['searchDamages'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof searchDamages>>, {data: BodyType<SearchDamagesRequestDto>;params?: SearchDamagesParams}> = (props) => {
          const {data,params} = props ?? {};

          return  searchDamages(data,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SearchDamagesMutationResult = NonNullable<Awaited<ReturnType<typeof searchDamages>>>
    export type SearchDamagesMutationBody = BodyType<SearchDamagesRequestDto>
    export type SearchDamagesMutationError = ErrorType<null | null | null | null>

    /**
 * @summary Search damages with filters and pagination, sorted by creation date (newest first)
 */
export const useSearchDamages = <TError = ErrorType<null | null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchDamages>>, TError,{data: BodyType<SearchDamagesRequestDto>;params?: SearchDamagesParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof searchDamages>>,
        TError,
        {data: BodyType<SearchDamagesRequestDto>;params?: SearchDamagesParams},
        TContext
      > => {

      const mutationOptions = getSearchDamagesMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Returns every damage on the vehicle that is still CREATED (not yet FIXED), newest first. A vehicle with no open damages answers 200 with an empty items list, never 404. Not paged: totalElements always equals the number of items.
 * @summary Get all open damages for a vehicle, sorted by creation date (newest first)
 */
export const getDamages = (
    vehicleId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<FleetDamagePageDto>(
      {url: `/fleet/incident/v1/vehicles/${vehicleId}/damages`, method: 'GET', signal
    },
      );
    }
  

export const getGetDamagesQueryKey = (vehicleId?: string,) => {
    return [`/fleet/incident/v1/vehicles/${vehicleId}/damages`] as const;
    }

    
export const getGetDamagesQueryOptions = <TData = Awaited<ReturnType<typeof getDamages>>, TError = ErrorType<null | null | null | null>>(vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDamages>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDamagesQueryKey(vehicleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDamages>>> = ({ signal }) => getDamages(vehicleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(vehicleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDamages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDamagesQueryResult = NonNullable<Awaited<ReturnType<typeof getDamages>>>
export type GetDamagesQueryError = ErrorType<null | null | null | null>


export function useGetDamages<TData = Awaited<ReturnType<typeof getDamages>>, TError = ErrorType<null | null | null | null>>(
 vehicleId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDamages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDamages>>,
          TError,
          Awaited<ReturnType<typeof getDamages>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDamages<TData = Awaited<ReturnType<typeof getDamages>>, TError = ErrorType<null | null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDamages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDamages>>,
          TError,
          Awaited<ReturnType<typeof getDamages>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDamages<TData = Awaited<ReturnType<typeof getDamages>>, TError = ErrorType<null | null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDamages>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all open damages for a vehicle, sorted by creation date (newest first)
 */

export function useGetDamages<TData = Awaited<ReturnType<typeof getDamages>>, TError = ErrorType<null | null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDamages>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDamagesQueryOptions(vehicleId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * The damage id is created by the backend and returned in the response. Photos are uploaded separately, after the damage exists. A new damage starts with status CREATED.
 * @summary Create a new damage report
 */
export const createDamage = (
    vehicleId: string,
    fleetCreateDamageRequestDto: BodyType<FleetCreateDamageRequestDto>,
 signal?: AbortSignal
) => {
      
      
      return customInstance<DamageDto>(
      {url: `/fleet/incident/v1/vehicles/${vehicleId}/damages`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fleetCreateDamageRequestDto, signal
    },
      );
    }
  


export const getCreateDamageMutationOptions = <TError = ErrorType<null | null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDamage>>, TError,{vehicleId: string;data: BodyType<FleetCreateDamageRequestDto>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createDamage>>, TError,{vehicleId: string;data: BodyType<FleetCreateDamageRequestDto>}, TContext> => {

const mutationKey = ['createDamage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDamage>>, {vehicleId: string;data: BodyType<FleetCreateDamageRequestDto>}> = (props) => {
          const {vehicleId,data} = props ?? {};

          return  createDamage(vehicleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateDamageMutationResult = NonNullable<Awaited<ReturnType<typeof createDamage>>>
    export type CreateDamageMutationBody = BodyType<FleetCreateDamageRequestDto>
    export type CreateDamageMutationError = ErrorType<null | null | null | null>

    /**
 * @summary Create a new damage report
 */
export const useCreateDamage = <TError = ErrorType<null | null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDamage>>, TError,{vehicleId: string;data: BodyType<FleetCreateDamageRequestDto>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createDamage>>,
        TError,
        {vehicleId: string;data: BodyType<FleetCreateDamageRequestDto>},
        TContext
      > => {

      const mutationOptions = getCreateDamageMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Returns vehicle info, design name, model file URL, and all damage points with full metadata. The modelFileUrl points at the sibling 3d-model/file endpoint on this same surface.
 * @summary Get structured 3D model data as JSON
 */
export const getDamageModelData = (
    vehicleId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<DamageModelDataDto>(
      {url: `/fleet/incident/v1/vehicles/${vehicleId}/damages/3d-model/data`, method: 'GET', signal
    },
      );
    }
  

export const getGetDamageModelDataQueryKey = (vehicleId?: string,) => {
    return [`/fleet/incident/v1/vehicles/${vehicleId}/damages/3d-model/data`] as const;
    }

    
export const getGetDamageModelDataQueryOptions = <TData = Awaited<ReturnType<typeof getDamageModelData>>, TError = ErrorType<null | null | null | null>>(vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDamageModelData>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDamageModelDataQueryKey(vehicleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDamageModelData>>> = ({ signal }) => getDamageModelData(vehicleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(vehicleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDamageModelData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDamageModelDataQueryResult = NonNullable<Awaited<ReturnType<typeof getDamageModelData>>>
export type GetDamageModelDataQueryError = ErrorType<null | null | null | null>


export function useGetDamageModelData<TData = Awaited<ReturnType<typeof getDamageModelData>>, TError = ErrorType<null | null | null | null>>(
 vehicleId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDamageModelData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDamageModelData>>,
          TError,
          Awaited<ReturnType<typeof getDamageModelData>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDamageModelData<TData = Awaited<ReturnType<typeof getDamageModelData>>, TError = ErrorType<null | null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDamageModelData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDamageModelData>>,
          TError,
          Awaited<ReturnType<typeof getDamageModelData>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDamageModelData<TData = Awaited<ReturnType<typeof getDamageModelData>>, TError = ErrorType<null | null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDamageModelData>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get structured 3D model data as JSON
 */

export function useGetDamageModelData<TData = Awaited<ReturnType<typeof getDamageModelData>>, TError = ErrorType<null | null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDamageModelData>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDamageModelDataQueryOptions(vehicleId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns the actual .glb file for the vehicle as a binary stream. The file is served from blob storage and can be several megabytes; consumers should cache it per design name rather than per request.
 * @summary Get the binary 3D model file (GLB)
 */
export const getDamageModelFile = (
    vehicleId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/fleet/incident/v1/vehicles/${vehicleId}/damages/3d-model/file`, method: 'GET', signal
    },
      );
    }
  

export const getGetDamageModelFileQueryKey = (vehicleId?: string,) => {
    return [`/fleet/incident/v1/vehicles/${vehicleId}/damages/3d-model/file`] as const;
    }

    
export const getGetDamageModelFileQueryOptions = <TData = Awaited<ReturnType<typeof getDamageModelFile>>, TError = ErrorType<null | null | null | null>>(vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDamageModelFile>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDamageModelFileQueryKey(vehicleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDamageModelFile>>> = ({ signal }) => getDamageModelFile(vehicleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(vehicleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDamageModelFile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDamageModelFileQueryResult = NonNullable<Awaited<ReturnType<typeof getDamageModelFile>>>
export type GetDamageModelFileQueryError = ErrorType<null | null | null | null>


export function useGetDamageModelFile<TData = Awaited<ReturnType<typeof getDamageModelFile>>, TError = ErrorType<null | null | null | null>>(
 vehicleId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDamageModelFile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDamageModelFile>>,
          TError,
          Awaited<ReturnType<typeof getDamageModelFile>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDamageModelFile<TData = Awaited<ReturnType<typeof getDamageModelFile>>, TError = ErrorType<null | null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDamageModelFile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDamageModelFile>>,
          TError,
          Awaited<ReturnType<typeof getDamageModelFile>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDamageModelFile<TData = Awaited<ReturnType<typeof getDamageModelFile>>, TError = ErrorType<null | null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDamageModelFile>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the binary 3D model file (GLB)
 */

export function useGetDamageModelFile<TData = Awaited<ReturnType<typeof getDamageModelFile>>, TError = ErrorType<null | null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDamageModelFile>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDamageModelFileQueryOptions(vehicleId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns one damage in full, including its photo URLs and any 3D damage points. Soft-deleted damages are not returned.
 * @summary Get damage detail by vehicle and damage ID
 */
export const getDamageDetail = (
    vehicleId: string,
    damageId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<DamageDto>(
      {url: `/fleet/incident/v1/vehicles/${vehicleId}/damages/${damageId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetDamageDetailQueryKey = (vehicleId?: string,
    damageId?: string,) => {
    return [`/fleet/incident/v1/vehicles/${vehicleId}/damages/${damageId}`] as const;
    }

    
export const getGetDamageDetailQueryOptions = <TData = Awaited<ReturnType<typeof getDamageDetail>>, TError = ErrorType<null | null | null | null>>(vehicleId: string,
    damageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDamageDetail>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDamageDetailQueryKey(vehicleId,damageId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDamageDetail>>> = ({ signal }) => getDamageDetail(vehicleId,damageId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(vehicleId && damageId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDamageDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDamageDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getDamageDetail>>>
export type GetDamageDetailQueryError = ErrorType<null | null | null | null>


export function useGetDamageDetail<TData = Awaited<ReturnType<typeof getDamageDetail>>, TError = ErrorType<null | null | null | null>>(
 vehicleId: string,
    damageId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDamageDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDamageDetail>>,
          TError,
          Awaited<ReturnType<typeof getDamageDetail>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDamageDetail<TData = Awaited<ReturnType<typeof getDamageDetail>>, TError = ErrorType<null | null | null | null>>(
 vehicleId: string,
    damageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDamageDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDamageDetail>>,
          TError,
          Awaited<ReturnType<typeof getDamageDetail>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDamageDetail<TData = Awaited<ReturnType<typeof getDamageDetail>>, TError = ErrorType<null | null | null | null>>(
 vehicleId: string,
    damageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDamageDetail>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get damage detail by vehicle and damage ID
 */

export function useGetDamageDetail<TData = Awaited<ReturnType<typeof getDamageDetail>>, TError = ErrorType<null | null | null | null>>(
 vehicleId: string,
    damageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDamageDetail>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDamageDetailQueryOptions(vehicleId,damageId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Marks the damage as inactive. Existing references and images remain, but the damage will no longer be returned by list or detail endpoints. The operation is idempotent: deleting an already-deleted damage succeeds.
 * @summary Soft-delete a damage report
 */
export const deleteDamage = (
    vehicleId: string,
    damageId: string,
 ) => {
      
      
      return customInstance<null>(
      {url: `/fleet/incident/v1/vehicles/${vehicleId}/damages/${damageId}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteDamageMutationOptions = <TError = ErrorType<null | null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDamage>>, TError,{vehicleId: string;damageId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteDamage>>, TError,{vehicleId: string;damageId: string}, TContext> => {

const mutationKey = ['deleteDamage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDamage>>, {vehicleId: string;damageId: string}> = (props) => {
          const {vehicleId,damageId} = props ?? {};

          return  deleteDamage(vehicleId,damageId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteDamageMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDamage>>>
    
    export type DeleteDamageMutationError = ErrorType<null | null | null | null>

    /**
 * @summary Soft-delete a damage report
 */
export const useDeleteDamage = <TError = ErrorType<null | null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDamage>>, TError,{vehicleId: string;damageId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteDamage>>,
        TError,
        {vehicleId: string;damageId: string},
        TContext
      > => {

      const mutationOptions = getDeleteDamageMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Links the damage (in the path) to the original damage it duplicates. Send a null/blank duplicateForDamageId to unmark. A damage cannot be marked as a duplicate of itself.
 * @summary Mark a damage as a duplicate of another damage
 */
export const markDamageAsDuplicate = (
    vehicleId: string,
    damageId: string,
    markDamageDuplicateRequestDto: BodyType<MarkDamageDuplicateRequestDto>,
 ) => {
      
      
      return customInstance<DamageDto>(
      {url: `/fleet/incident/v1/vehicles/${vehicleId}/damages/${damageId}/duplicate`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: markDamageDuplicateRequestDto
    },
      );
    }
  


export const getMarkDamageAsDuplicateMutationOptions = <TError = ErrorType<null | null | null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markDamageAsDuplicate>>, TError,{vehicleId: string;damageId: string;data: BodyType<MarkDamageDuplicateRequestDto>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof markDamageAsDuplicate>>, TError,{vehicleId: string;damageId: string;data: BodyType<MarkDamageDuplicateRequestDto>}, TContext> => {

const mutationKey = ['markDamageAsDuplicate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markDamageAsDuplicate>>, {vehicleId: string;damageId: string;data: BodyType<MarkDamageDuplicateRequestDto>}> = (props) => {
          const {vehicleId,damageId,data} = props ?? {};

          return  markDamageAsDuplicate(vehicleId,damageId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MarkDamageAsDuplicateMutationResult = NonNullable<Awaited<ReturnType<typeof markDamageAsDuplicate>>>
    export type MarkDamageAsDuplicateMutationBody = BodyType<MarkDamageDuplicateRequestDto>
    export type MarkDamageAsDuplicateMutationError = ErrorType<null | null | null | null | null>

    /**
 * @summary Mark a damage as a duplicate of another damage
 */
export const useMarkDamageAsDuplicate = <TError = ErrorType<null | null | null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markDamageAsDuplicate>>, TError,{vehicleId: string;damageId: string;data: BodyType<MarkDamageDuplicateRequestDto>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markDamageAsDuplicate>>,
        TError,
        {vehicleId: string;damageId: string;data: BodyType<MarkDamageDuplicateRequestDto>},
        TContext
      > => {

      const mutationOptions = getMarkDamageAsDuplicateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Moves a damage between CREATED (open) and FIXED (closed). A FIXED damage no longer appears in the vehicle's open-damage list. Unlike the other operations on this controller, this one is restricted to BattAdmin: closing a damage is an administrative decision, not a fleet-management one.
 * @summary Update the status of a damage report
 */
export const updateDamageStatus = (
    vehicleId: string,
    damageId: string,
    updateDamageStatusRequestDto: BodyType<UpdateDamageStatusRequestDto>,
 ) => {
      
      
      return customInstance<DamageDto>(
      {url: `/fleet/incident/v1/vehicles/${vehicleId}/damages/${damageId}/status`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateDamageStatusRequestDto
    },
      );
    }
  


export const getUpdateDamageStatusMutationOptions = <TError = ErrorType<null | null | null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDamageStatus>>, TError,{vehicleId: string;damageId: string;data: BodyType<UpdateDamageStatusRequestDto>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateDamageStatus>>, TError,{vehicleId: string;damageId: string;data: BodyType<UpdateDamageStatusRequestDto>}, TContext> => {

const mutationKey = ['updateDamageStatus'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDamageStatus>>, {vehicleId: string;damageId: string;data: BodyType<UpdateDamageStatusRequestDto>}> = (props) => {
          const {vehicleId,damageId,data} = props ?? {};

          return  updateDamageStatus(vehicleId,damageId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateDamageStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateDamageStatus>>>
    export type UpdateDamageStatusMutationBody = BodyType<UpdateDamageStatusRequestDto>
    export type UpdateDamageStatusMutationError = ErrorType<null | null | null | null | null>

    /**
 * @summary Update the status of a damage report
 */
export const useUpdateDamageStatus = <TError = ErrorType<null | null | null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDamageStatus>>, TError,{vehicleId: string;damageId: string;data: BodyType<UpdateDamageStatusRequestDto>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateDamageStatus>>,
        TError,
        {vehicleId: string;damageId: string;data: BodyType<UpdateDamageStatusRequestDto>},
        TContext
      > => {

      const mutationOptions = getUpdateDamageStatusMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    